import { render, staticRenderFns } from "./ProfitUnsubscribeView.vue?vue&type=template&id=ffbcb816&scoped=true"
import script from "./ProfitUnsubscribeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfitUnsubscribeView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProfitUnsubscribeView.vue?vue&type=style&index=0&id=ffbcb816&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbcb816",
  null
  
)

export default component.exports